import { render, staticRenderFns } from "./OmbudsmanView.vue?vue&type=template&id=31ec3300&"
import script from "./OmbudsmanView.vue?vue&type=script&lang=js&"
export * from "./OmbudsmanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports